import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core'
import { Globals } from '../../../../../../../globals';
import { ConfigurationServices } from '../../../../../services';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-varitations-add-elements-select',
    templateUrl: 'configuration-varitations-add-elements-select.html',
})
export class ConfigurationVariationsAddElementsSelectPage {

    @Input() variation;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };
    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public globals: Globals,
        public configurationServices: ConfigurationServices,
        public translate: TranslateService) {
    }

    nextPage() {
        if (this.configurationServices.page_active < this.configurationServices.pages_dishes_products.length) {
            this.configurationServices.page_active += 1
        }
        this.configurationServices.getListDishesProducts();
        document.getElementById('dishes_products').scrollIntoView({
            behavior: 'smooth'
        });
    }
    previusPage() {
        if (this.configurationServices.page_active > 1) {
            this.configurationServices.page_active -= 1;
        }
        this.configurationServices.getListDishesProducts();
        document.getElementById('dishes_products').scrollIntoView({
            behavior: 'smooth'
        });
    }
    activePage(number) {
        this.configurationServices.page_active = number;
        this.configurationServices.getListDishesProducts();
        document.getElementById('dishes_products').scrollIntoView({
            behavior: 'smooth'
        });
    }

    insert(element) {
        if (!this.check(element.UID)) { //Buscamos si el elemento ya esta añadido
            var _array: any;
            _array = {
                'UID': element.UID,
                'name': element.name,
                'name_es': element.name_es,
                'name_ca': element.name_ca,
                'name_en': element.name_en,
                'name_de': element.name_de,
                'name_it': element.name_it,
                'name_fr': element.name_fr,
                'type': element.type
            };

            var variations_elements = element.variations_favourite;
            if (variations_elements == undefined) {
                variations_elements = [];
            }
            variations_elements.push({
                'name_static': this.variation.name,
                'price_static': this.variation.price,
                'type_static': this.variation.type,
                'uid': this.variation.UID,
            });

            var message = this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectProduct(element) + ' ' + this.translate.instant('instant-anadido-correctemente');
            if (element.type == 'product') {
                message = this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(element) + ' ' + this.translate.instant('instant-anadido-correctemente')
                this.configurationServices.firestore.collection('products').doc(element.UID).update({
                    'variations_favourite': variations_elements,
                });
            } else {
                this.configurationServices.firestore.collection('dish').doc(element.UID).update({
                    'variations_favourite': variations_elements,
                });
            }
            this.configurationServices.dishes_products_array_tmp.push(_array);
            this.configurationServices.dishes_products_array_tmp = [...this.configurationServices.dishes_products_array_tmp];
            let toast = this.toastCtrl.create({
                message: message,
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-elemento-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        this.configurationServices.dishes_products_array_tmp.forEach(element => {
            if (element.UID == value) {
                response = true;
            }
        });
        return response;
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/configuration-variations-create/configuration-variations-create-info/configuration-variation-add-elements/configuration-varitations-add-elements-select/configuration-varitations-add-elements-select.ts